module.exports = require('./reserved-words');



//////////////////
// WEBPACK FOOTER
// ./~/reserved-words/lib/index.js
// module id = 1626
// module chunks = 1